// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frm-widget-group-title {\n  font-size: 15px;\n  color: #999;\n  padding: 6px 16px;\n  border-top: 1px solid #eeeeee;\n  border-bottom: 1px solid #eeeeee;\n}\n.frm-widget-group .adm-grid-item:first-of-type .adm-list-item-content {\n  border-top: none;\n}\n", ""]);
// Exports
module.exports = exports;
